import { http, providerApi } from "@/core/api/";
import documentsService from "@/services/documents";

const deticketsBaseURL = "api/supportticket";

export const getUserCases = (params, pageIndex, pageSize) =>
  http.get(`${deticketsBaseURL}/search`, {
    params: { ...params, pageIndex, pageSize }
  });

export const getUserCaseStatus = (deptsId) => http.get(`${deticketsBaseURL}/status`,{
  params: {
    deptsId: deptsId
  },
  paramsSerializer: params => {    
    return Object.entries(params)
      .map(([key, val]) =>
        Array.isArray(val)
          ? val.map(v => `${key}=${v}`).join('&')
          : `${key}=${val}`
      )
      .join('&');
  }
});

export const getUserCaseModules = () =>
  http.get(`${deticketsBaseURL}/modules/eduesp`);

export const getUserCaseScreens = moduleId =>
  http.get(`${deticketsBaseURL}/screens/${moduleId}`);

export const getUserCaseReferenceNumberTypes = params =>
  http.get(`${deticketsBaseURL}/referencenumbertypes`, { params: params });

export const getUserCaseById = itemId =>
  http.get(`${deticketsBaseURL}/case/${itemId}`);

export const saveUserCase = formData =>
  http.post(`${deticketsBaseURL}/create`, formData);

export const downloadDocument = async documentId => {
  http.get(`${deticketsBaseURL}/download/${documentId}`).then(res => {
    documentsService.Download(res.data);
  });
};
export const deleteCase = itemId =>
  http.delete(`${deticketsBaseURL}/case`, {
    params: {
      itemId
    }
  });

export const saveAdditionalInfo = formData =>
  http.post(`${deticketsBaseURL}/saveadditionalinformation`, formData);

export const saveCommentManagement = formData =>
  http.post(`${deticketsBaseURL}/savecommentmanagement`, formData);

export const getCommentHistory = caseNumber =>
  http.get(`${deticketsBaseURL}/commentshistory`, {
    params: {
      caseNumber
    }
  });

export const getPreviousContactInformation = () =>
  http.get(`${deticketsBaseURL}/previouscontactinformation`);

export const validateReferenceNumber = (reference, referenceType) =>
  http.get(
    `${deticketsBaseURL}/validatereferencenumber?reference=${reference}&referenceType=${referenceType}`
  );

export const getCaseModules = (params) => {
  return http.get(`${deticketsBaseURL}/modules`, { params });
};

export const getTicketCatalogues = (itemSubTypeId) => {
  return http.get(`${deticketsBaseURL}/ticketcatalogues/${itemSubTypeId}`);
};

export const changeStatusTicket = (payload) => {
  return http.put(`${deticketsBaseURL}/changestatusticket`, payload);
}

export const getItemSubTypes = () => {
  return http.get(`${deticketsBaseURL}/itemsubtypes`);
};

